const video = document.querySelector('.main-video video')

const play = () => video.play()
const pause = () => video.pause()

const init = () => {
	if (video) {
		//setTimeout(pause, 200)
		video.addEventListener("mouseover", play)
		video.addEventListener("mouseleave", pause)
	}
}

export default {
	init,
};
